<template>
  <div class="news-item">
    <div
      class="news-img"
      :style="{ backgroundImage: 'url(' + newsData.imgPath + ')' }"
    ></div>
    <div class="news-header">
      <div class="news-title">{{ newsData.title }}</div>
      <div class="news-date">{{ newsDate }}</div>
    </div>
    <router-link
      class="news-subtitle"
      :to="{ path: '/news', query: { page: this.page, id: this.newsData.id } }"
    >
      {{ newsData.subTitle }}
    </router-link>
    <div class="news-clear" />
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'NewsItem',
  props: {
    page: String,
    newsData: {
      id: String,
      title: String,
      subTitle: String,
      imgPath: String,
      detail: String,
      date: String,
    },
  },
  computed: {
    newsDate: function() {
      return moment(String(this.newsData.date)).format('YYYY/MM/DD');
    },
  },
};
</script>

<style scoped>
.news-item {
  height: 170px;
}

.news-header {
  margin-left: 240px;
  top: 10px;
  height: 40px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #000000;
}

.news-title {
  font-size: 18px;
  text-align: left;
  height: 30px;
  line-height: 30px;
  font-weight: bold;
  color: #000000;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: calc(100% - 70px);
}

.news-subtitle {
  margin-top: 10px;
  margin-left: 240px;
  height: 80px;
  text-align: left;
  font-size: 16px;
  line-height: 26px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: start;
}

.news-img {
  width: 210px;
  height: 130px;
  float: left;
  background-size: 100%;
  background-position: top center;
  background-repeat: no-repeat;
}

.news-date {
  font-size: 14px;
  height: 30px;
  line-height: 30px;
  color: #828282;
  text-align: right;
  width: 100px;
}

@media (max-width: 767px) {
  .news-item {
    height: auto;
    text-align: center;
  }

  .news-header {
    display: block;
    height: auto;
    margin-left: 0px;
  }

  .news-title {
    margin-top: 10px;
    width: 100%;
    height: auto;
    line-height: auto;
    white-space: normal;
  }

  .news-date {
    height: auto;
    line-height: auto;
    margin-bottom: 5px;
    width: 100%;
  }

  .news-img {
    width: 100%;
    height: 60vw;
    float: none;
    background-position: center center no-repeat;
  }

  .news-subtitle {
    margin-left: 0px;
    -webkit-line-clamp: 4;
    height: 105px;
  }

  .news-clear {
    width: 100%;
    height: 50px;
    clear: both;
  }
}
</style>
